import axios from "axios";
import { getFromLocalStorage } from "lib/common/helper/LocalStorage";
import { vaildUserName } from "lib/common/types/user";
import { useCallback, useState } from "react";
import { host } from "../../../utils/constants";

function useCheckUsername() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [validUsername, setValidUsername] = useState<vaildUserName>();

  const checkUser = useCallback((value) => {
    setLoading(true);
    setError(null);

    const token = getFromLocalStorage("registerToken");

    axios
      .post(host + `/auth/register/check_username`, {
        ...value,
        token: token,
      })
      .then(({ data: { data, success } }) => {
        setSuccess(success);
        if (data) {
          setValidUsername(data);
        }
      })
      .catch((err) => {
        setError(err.response.data);
      })
      .finally(() => setLoading(false));
  }, []);

  return { checkUser, loading, error, success, validUsername };
}

export default useCheckUsername;
